import { Injectable } from "@angular/core";
import { HttpParameter } from "../datatypes/misc";
import { HttpClientHelper } from "../helpers/HttpClientHelper";
import { OptionalFieldSettings, FormSettings } from "../models/optionalFieldSettings.model";
import { Observable } from "rxjs";

@Injectable()
export class OptionalFieldService {

    constructor(private httpClientHelper: HttpClientHelper) {
    }

    public getFormOptionalFields(formName: string): Observable<FormSettings> {
        return this.httpClientHelper.httpGet(new HttpParameter('OptionalField.GetOptionalFieldsByForm', [formName]));
    }

    public getConfigurableForms(): Observable<FormSettings[]> {
        return this.httpClientHelper.httpGet(new HttpParameter('OptionalField.GetConfigurableForms'));
    }

    public updateOptionalFields(optionalFields: OptionalFieldSettings[]): Observable<boolean> {
        const httpHelperParams = new HttpParameter('OptionalField.UpdateOptionalFields', [], optionalFields);
        return this.httpClientHelper.httpPut(httpHelperParams);
    }

}